import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-421d425a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "データ取得日時", -1))
const _hoisted_3 = { class: "grid-item-head" }
const _hoisted_4 = { class: "grid-item-head-index" }
const _hoisted_5 = { class: "grid-item-head-title" }
const _hoisted_6 = { class: "grid-item-body" }
const _hoisted_7 = { class: "values" }
const _hoisted_8 = { class: "values-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "A.P.+", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "m", -1))
const _hoisted_12 = { class: "values-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "水位天端", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "m", -1))

import { PropType, computed } from 'vue'
import { sortBy } from 'lodash'
import WaterDiagram from '@/components/common/WaterDiagram.vue'
import { usePresentStore } from '@/stores/presentStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { DefinitionInfoSummaryItemCommon } from '@/models/initData/DefinitionInfo'
import { Threshold } from '@/models/InitData'
import { renderValue } from '@/lib/formatter'


export default /*#__PURE__*/_defineComponent({
  props: {
  cell: {
    type: Object as PropType<DefinitionInfoSummaryItemCommon>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const presentStore = usePresentStore()
const initDataStore = useInitDataStore()


const station = computed(() => {
  const { stationId } = props.cell.args

  return initDataStore.initData.stations.findById(stationId)
})

const cell = computed(() => props.cell)
const thresholds = computed(() => {
  return sortBy(station.value?.threshold?.filter(t => t.type === 'water') || [], 'comparison')
    .reverse()
    .reduce((memo, t) => {
      memo[t.status] = t

      return memo
    }, {} as { [key: string]: Threshold })
})

const current = computed(() => {
  const { stationId } = props.cell.args

  return presentStore.getValue(stationId, 'waterLevel')
})

const ap = computed(() => {
  const { ap } = props.cell.args

  if (current.value === undefined || ap === undefined) {
    return
  }

  return current.value + ap
})

const arrowStyle = computed(() => {
  const { stationId } = props.cell.args
  const diff = presentStore.getDiff(stationId, 'waterLevel') || 0
  const deg = diff > 0 ? -45 : diff < 0 ? 45 : 0

  return {
    transform: `rotate(${deg}deg)`,
  }
})

const params = computed(() => {
  return {
    value: current.value,
    thresholds: thresholds.value,
    scale: station.value?.scale,
    type: 'data-summary',
    ap: props.cell.args.ap,
    showTooltip: false,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: `popup-${_unref(cell).args.no}`,
      class: "popup"
    }, [
      _hoisted_2,
      _createElementVNode("p", null, _toDisplayString(_unref(presentStore).getTime(_unref(cell).args.stationId)), 1)
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(cell).args.no), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(station)?.name), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(WaterDiagram, _normalizeProps(_guardReactiveProps(_unref(params))), null, 16),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(renderValue)(_unref(ap), 2)), 1),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", {
            style: _normalizeStyle(_unref(arrowStyle)),
            class: "arrow"
          }, null, 4),
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(renderValue)(_unref(current), 2)), 1),
          _hoisted_15
        ])
      ])
    ])
  ], 64))
}
}

})